import React, { Component } from 'react'

import { Header, Divider, Grid, Button, Form, Select } from 'semantic-ui-react'
import AdminLayout from '../components/AdminLayout'
import ManageUserTable from '../components/ManageUserTable'

// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { adminGetUsers } from '../actions/admin'

class ManageUserPage extends Component {
  state = {
    offset: 0,
    limit: 200,
    enabled: true
  }
  componentWillMount() {
    const { offset, limit, enabled } = this.state
    this.props.adminGetUsers({ offset, limit, enabled })
  }
  loadMore() {
    let { offset, limit, enabled } = this.state
    offset = offset + limit
    const state = this.state
    this.setState({ offset })
    this.props.adminGetUsers({ ...state, offset, enabled })
  }
  handleChange(e, data) {
    let [offset, limit] = [0, 200]
    this.setState({
      offset,
      limit,
      enabled: data.value
    })
    this.props.adminGetUsers({
      offset,
      limit,
      enabled: data.value,
      refresh: true
    })
  }
  render() {
    const { limit } = this.state
    const { users, isUsersLoading } = this.props.admin
    return (
      <AdminLayout isLoading={isUsersLoading}>
        <Header as="h3">Manage Users</Header>
        <Divider />
        <Grid>
          <Grid.Column>
            <Form>
              <Form.Group>
                <Form.Field
                  label="Enabled/Disabled"
                  placeholer="Select Enabled/Disabled"
                  control={Select}
                  onChange={this.handleChange.bind(this)}
                  options={[
                    { key: 0, text: 'Any', value: '' },
                    { key: 1, text: 'Enabled', value: true },
                    { key: 2, text: 'Disabled', value: false }
                  ]}
                />
              </Form.Group>
            </Form>
          </Grid.Column>
        </Grid>
        <ManageUserTable users={users} />

        <Grid>
          <Grid.Row centered>
            <Grid.Column width={4}>
              <Button
                fluid
                circular
                basic
                onClick={this.loadMore.bind(this)}
                disabled={users.length < limit}
                content={users.length < limit ? 'No more users.' : 'Load More'}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AdminLayout>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      adminGetUsers
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserPage)



// WEBPACK FOOTER //
// ./src/pages/ManageUsers.jsx